import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpUserEvent } from '@angular/common/http';
import { Observable, BehaviorSubject, pipe, throwError } from 'rxjs';
import {  tap, catchError, switchMap, finalize, filter, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

    isRefreshingToken: boolean = false;
    returnURL : any;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

 constructor(private loginService : AuthenticationService,private router: Router){}

 intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.returnURL = this.router.routerState.snapshot;

    const stored = localStorage.getItem('loginResultDto');
    const loginResultDto = stored ? JSON.parse(stored) : null;

    if (loginResultDto && loginResultDto.access_token) {
      request = this.addToken(request, loginResultDto.access_token);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 400:
              return this.handle400Error(error);
            case 401:
              return this.handle401Error(request, next);
            default:
              return throwError(() => error);
          }
        } else {
          return throwError(() => error);
        }
      })
    );
  }

 
  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    if(request.url.includes('admin_DocumentUpload/upload')){    
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*'
      }
    });
   }

   if(request.url.includes('api/v1/token')){ 
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*'
     
      }
    });
   }

    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Content-Type':'application/json' ,
      //  'Access-Control-Allow-Origin': '*'
      }
    });
    
  }

  private handle400Error(error: HttpErrorResponse): Observable<never> {
    if (error.error && error.error.error === 'invalid_grant') {
      this.logoutUser();
    }
    return throwError(() => error);
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;
      this.tokenSubject.next(null);
      console.log('Get Refresh Token');
      
      const stored = localStorage.getItem('loginResultDto');
      const loginResultDto = stored ? JSON.parse(stored) : null;

      if (!loginResultDto || !loginResultDto.refresh_token) {
        this.logoutUser();
        return throwError(() => 'No refresh token found');
      }
      
      return this.loginService.refreshToken(loginResultDto.refresh_token).pipe(
        switchMap((refreshResult: any) => {
          if (refreshResult && refreshResult.access_token) {
            const updatedLogin = {
              ...loginResultDto,
              access_token: refreshResult.access_token,
              refresh_token: refreshResult.refresh_token
            };
            localStorage.setItem('loginResultDto', JSON.stringify(updatedLogin));

            this.tokenSubject.next(refreshResult.access_token);

            return next.handle(this.addToken(req, refreshResult.access_token));
          } else {
            this.logoutUser();
            return throwError(() => 'Invalid refresh token response');
          }
        }),
        catchError(error => {
          this.logoutUser();
          return throwError(() => error);
        }),
        finalize(() => {
          this.isRefreshingToken = false;
        })
      );
    } else {
      return this.tokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => next.handle(this.addToken(req, token!)))
      );
    }
  }

 
  private logoutUser(): void {
    this.loginService.logout();
    this.router.navigate(['auth/login'], { queryParams: { returnUrl: this.returnURL.url } });
  }

}
